import React from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

/**
 * Reusable Paginator. Renders when pages > 1.
 * Props: page (current), pages (total), onChange (fn(newPage))
 */
export default function Paginator({ page, pages, onChange, total, perPage = 10 }) {
  if (!pages || pages <= 1) return null;
  const start = Math.max(0, page - 3);
  const end = Math.min(pages, page + 2);
  const buttons = [];
  for (let p = start + 1; p <= end; p++) buttons.push(p);
  return (
    <div className="p-4 border-t border-[var(--border)] flex items-center justify-between">
      <button
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        data-testid="prev-page"
        className="btn-ghost text-xs flex items-center gap-1 disabled:opacity-30"
      >
        <CaretLeft size={14} /> Anterior
      </button>
      <div className="flex items-center gap-2">
        {total != null && <div className="text-xs text-white/40 mr-3">{total} itens · {perPage}/pág</div>}
        {buttons.map((p) => (
          <button
            key={p}
            onClick={() => onChange(p)}
            data-testid={`page-${p}`}
            className={`w-8 h-8 rounded-sm text-xs font-mono ${page === p ? "bg-[var(--accent)] text-black font-bold" : "border border-[var(--border)] text-white/60 hover:text-white"}`}
          >
            {p}
          </button>
        ))}
      </div>
      <button
        onClick={() => onChange(Math.min(pages, page + 1))}
        disabled={page >= pages}
        data-testid="next-page"
        className="btn-ghost text-xs flex items-center gap-1 disabled:opacity-30"
      >
        Próxima <CaretRight size={14} />
      </button>
    </div>
  );
}
